<template>
    <div class="row pt-3">
        <div class="col-12">
            <div class="form-check pl-0 pr-5 md-form mb-3"
                 v-if="currentPartner.approvalStatusId === partnerApprovalEnum.Pending && contractDetails.requestStatusId === contractStatusEnum.Pending">
                <input class="form-check-input filled-in" type="checkbox" id="acknowledgement" v-model="acknowledged">
                <label class="form-check-label" for="acknowledgement">
                    أقرّ بصحة البيانات والمعلومات المدخلة، كما أقرّ بعلمي التام بالآثار النظاميّة المترتبة على هذه
                    العمليّة التوثيقيّة، ومنها أن الوثيقة التي ستصدر لهذا العقد تعدّ سندًا تنفيذيًّا تسري عليها
                    أحكام الأنظمة ذات الصلة بالتنفيذ.
                </label>
            </div>
            <hr class="footer-hr pt-0 mt-0" />
            <div class="d-flex float-left">
                <template v-if="currentPartner.approvalStatusId === partnerApprovalEnum.Pending && contractDetails.requestStatusId === contractStatusEnum.Pending">
                    <button class="btn btn-outline-danger mx-4 px-8" @click="onHandleAction('RejectRequest')"
                            :disabled="!acknowledged">
                        رفض {{
 contractDetails.requestTypeId === requestTypeEnum.ContractAttestation ?
              'توثيق' : 'تسوية'
                        }} العقد
                    </button>
                    <button type="submit" class="btn button--greenFill px-8" @click="onHandleAction('ApproveRequest')"
                            :disabled="!acknowledged">
                        قبول {{
 contractDetails.requestTypeId === requestTypeEnum.ContractAttestation ?
              'توثيق' : 'تسوية'
                        }} العقد
                    </button>
                </template>
                <template v-if="!isRequest">
                    <!--<button type="button" class="btn btn-outline-danger mx-4 px-8"
                            v-if="contractDetails.contractStatusId === contractStatusEnum.Valid"
                            @click="onHandleAction('SettleContract')">
                        تسوية
                        العقد
                    </button>-->
                    <button class="btn btn-outline-primary mx-4 px-4"
                            v-if="contractDetails.contractStatusId === contractStatusEnum.Valid || contractDetails.contractStatusId === contractStatusEnum.Expired"
                            @click="onHandleAction('DownloadContract')">
                        <i class="fal fa-sign-in fa-rotate-90 ml-2"></i>تحميل
                        وثيقة العقد
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';

    import { ContractDetails } from '@/models/contract.model';
    import { ContractStatusEnum } from '@/enums/contract-status.enum';
    import { ContractPartnerModel } from '@/models/contractPartnerModel';
    import { PartnerApprovalEnum } from '@/enums/partnerApprovalEnum';
    import { ContractAction as Action } from '@/models/actions.models';
    import { RequestTypeEnum } from '@/enums/request-type.enum';

    @Component
    export default class ContractActionsComponent extends Vue {
        @Prop({ required: true }) contractDetails!: ContractDetails;
        @Prop({ required: false }) currentPartner!: ContractPartnerModel;

        /** The contract status enum. */
        contractStatusEnum = ContractStatusEnum;

        /** The partner approval enum. */
        partnerApprovalEnum = PartnerApprovalEnum;

        /** The request type enum. */
        requestTypeEnum = RequestTypeEnum;

        /** Holds the selected action. */
        action?: Action;

        /** Used to determine the approval acknowledgement. */
        acknowledged = false;

        /** Used to distinguish whether the loaded data is a request or a contract. */
        isRequest = false;

        mounted() {
            this.isRequest = this.$route.name === 'requestDetails';
        }

        /**
         * Handles the various view actions.
         * @param action The action to be performed.
         * @returns void
         */
        onHandleAction(action: Action): void {
            //if (!this.acknowledged && action !== 'SettleContract') return;
            if (!this.acknowledged && (this.currentPartner.approvalStatusId === this.partnerApprovalEnum.Pending && this.contractDetails.requestStatusId === this.contractStatusEnum.Pending)) return;

            this.$emit('click:action', action);
        }
    }
</script>
